import { useEffect } from 'react';
import { isEasyBathrooms } from '../constants/stores';

export const useWindowHandlers = () => {
  useEffect(() => {
    (window as unknown as Record<string, unknown>).onCTA = (
      callback: ({ cta, storeId }: { cta: string; storeId: string }) => void
    ) => {
      (window as unknown as Record<string, unknown>).onCTACallbacks = callback;
    };

    (
      window as unknown as Record<
        string,
        (p: (q: { cta: string; storeId: string }) => void) => void
      >
    ).onCTA(({ cta, storeId }) => {
      if (isEasyBathrooms(storeId)) {
        if (cta === 'book_appointment') {
          (
            window as unknown as Record<string, (str: string) => void>
          )?.openModalTQT?.('book-an-appointment');
        }
      }
    });
  }, []);
};
